/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  if ($(window).width() > 800) {
    var sr = ScrollReveal();

    sr.reveal('.faq__title', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });

    // Reveal the whole questions block as ONE animation (not question-by-question) — reveal the
    // `.faq__list` wrapper (which now carries `.sr-hidden`) instead of each `.faq__item`.
    sr.reveal('.faq__list', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });

    sr.reveal('.faq__footer', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });

    faqRevealFallback();
  }

  // Fast-scroll / load safeguard. A fast scroll or a page load where a `.sr-hidden` element never
  // crosses ScrollReveal's trigger point can leave it stuck hidden (title, the whole `.faq__list`
  // block, or footer). Watch each `.sr-hidden` independently (threshold 0.1 so a list taller than
  // the viewport still triggers), give ScrollReveal a beat, then reveal only the ones still stuck.
  function faqRevealFallback() {
    if (!('IntersectionObserver' in window)) return;
    var items = document.querySelectorAll('section.faq .sr-hidden');
    if (!items.length) return;
    var io = new IntersectionObserver(faqOnItemInView, { threshold: 0.1 });
    items.forEach(function (el) { io.observe(el); });
  }

  function faqOnItemInView(entries, observer) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      // Let ScrollReveal's own reveal finish first, then only handle a miss.
      setTimeout(function () { faqRevealIfMissed(el); }, 600);
    });
  }

  function faqRevealIfMissed(el) {
    if (parseFloat(getComputedStyle(el).opacity) >= 0.95) return;
    el.style.transition =
      'opacity 700ms cubic-bezier(0.25, 0.1, 0.25, 1), transform 1300ms cubic-bezier(0.25, 0.1, 0.25, 1)';
    el.style.visibility = 'visible';
    el.style.opacity = '1';
    el.style.transform = 'translateY(0)';
  }

  $(document).on('click', '.js-faq-item .faq__question', function () {
    var $btn = $(this);
    var $item = $btn.closest('.js-faq-item');
    var $list = $item.closest('.faq__list');
    var $items = $list.length ? $list.find('.js-faq-item') : $item;
    var isOpen = $btn.attr('aria-expanded') === 'true';

    $items.each(function () {
      $(this).find('.faq__question').attr('aria-expanded', 'false');
      $(this).removeClass('faq__item--open');
    });

    if (!isOpen) {
      $btn.attr('aria-expanded', 'true');
      $item.addClass('faq__item--open');
    }
  });

  $(document).on('click', '.faq__btn--scroll-top', function (e) {
    e.preventDefault();
    if (window.lenis && typeof window.lenis.scrollTo === 'function') {
      window.lenis.scrollTo(0);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
});